export default __webpack_public_path__ + "static/media/orange-checkmark.f548cb4b.svg";